<template>
  <input :class="{ 'is-invalid': hasError }" v-on="$listeners" v-bind="$attrs" >
</template>

<script>
import ErrorMixin from '../../mixins/error-mixin';

export default {
  name: 'BaseInput',
  mixins: [ErrorMixin]
};
</script>

<style scoped>
.el-table th div {
  padding-left: 0;
  padding-right: 0;
}
</style>
